const rotate = {
    title: ' Tourism Expo 2020',
    name: 'AI',
    desc: 'Digital Exhibition hall',
    btn: {
        desc: 'Exhibition',
        prev: 'Prev',
        next: 'Next',
        enter: 'Enter Exhibiton'
    },

    bannerList:[{
        name: 'Comfortable Sichuan Exhibition',
        url: '/vr1',
        pic: 'https://hlw-1254378658.piccd.myqcloud.com/pic-02.gif',
        src: 'https://hlw-1254378658.piccd.myqcloud.com/01.mp4',
        small: 'https://hlw-1254378658.piccd.myqcloud.com/pic-01.png?imageMogr2/thumbnail/150x',
    },{
        name: 'City Gift Exhibition',
        url: '/vr3',
        pic: 'https://hlw-1254378658.piccd.myqcloud.com/pic-01.gif',
        src: 'https://hlw-1254378658.piccd.myqcloud.com/02.mp4',
        small: 'https://hlw-1254378658.piccd.myqcloud.com/pic-02.png?imageMogr2/thumbnail/150x',
    },{
        name: 'Tourism destination integration Exhibition',
        url: '/vr4',
        pic: 'https://hlw-1254378658.piccd.myqcloud.com/pic-03.gif',
        src: 'https://hlw-1254378658.piccd.myqcloud.com/03.mp4',
        small: 'https://hlw-1254378658.piccd.myqcloud.com/pic-03.png?imageMogr2/thumbnail/150x',
    },{
        name: 'Cultural Tourism New Technology Exhibition',
        url: '/vr5',
        pic: 'https://hlw-1254378658.piccd.myqcloud.com/pic-05.gif',
        src: 'https://hlw-1254378658.piccd.myqcloud.com/04.mp4',
        small: 'https://hlw-1254378658.piccd.myqcloud.com/pic-04.png?imageMogr2/thumbnail/150x',
    },{
        name: 'Cultural Tourism China Innovation Pavilion',
        url: '/vr2',
        pic: 'https://hlw-1254378658.piccd.myqcloud.com/pic-04.gif',
        src: 'https://hlw-1254378658.piccd.myqcloud.com/05.mp4',
        small: 'https://hlw-1254378658.piccd.myqcloud.com/pic-05.png?imageMogr2/thumbnail/150x',
    }],
    navs: [{
        name: 'AI Exhibition',
        isActive: true,
        url: './'
      },{
        name: 'Live',
        isActive: false,
        url: 'http://qr28.cn/BLpEoA'
      },{
        name: 'Transition',
        isActive: false,
        url: 'https://thenextravelmarket.com/vptm2020'
      },{
        name: 'News',
        isActive: false,
        url: 'https://www.henglvwang.cn/list-221-1.html'
      }],
    copyright: 'Copyright: Sichuan International Tourism Fair ICP备案/许可证号：蜀ICP备19027923号',

    ask: {
        robot:'Click to Q/A',
        title: 'Click for information',
        list:[{
          key: 'Expo',
          q: 'Introduction to the Expo',
          a: 'Sichuan International Tourism Trade Fair was founded in 2014. It is held every autumn in Emeishan City, Leshan City, and has been successfully held for six times. Sichuan International Tourism Trade Fair is the cultural tourism industry trade fair with the largest scale and industry influence in Western China. It is an important platform for international cultural tourism industry to display tourism image and promote tourism cooperation.',
          isSelect: true
        },{
          key: 'Address',
          q: 'Address of exhibition hall',
          a: 'The 7th Sichuan International Tourism Trade Fair is scheduled to be held from September 25 to 28, 2020 at Sichuan International Tourism Trade Expo Center, Emeishan City, Leshan City, Sichuan Province. Public transportation: you can take the motor car to Emeishan station and transfer to Emeishan No.6 bus to the exhibition hall; self driving travel: about 50 meters southwest from the intersection of Lvbo Avenue and Gonghai road in Emeishan City. (about 100m to the south of Crystal Plaza)',
          isSelect: false
        },{
          key: 'Opening time',
          q: 'Opening time',
          a: 'The 7th Sichuan International Tourism Fair is scheduled to be held from September 25 to 28, 2020. The public opening hours are 13:30-17:00 on September 25, 09:00-17:00 on September 26, 09:00-17:00 on September 27, and 09:00-12:00 on September 28.',
          isSelect: false
        },{
          key: 'Ticket',
          q: 'Ticket Service',
          a: 'The way of booking into the Library: 1. Mobile phone WeChat follow the Wechat official account ：HengLvwang, and 2. Click the bottom menu bar: "Hui Zhan Fu Wu"; 3, click "Piao Wu Tong" to make an appointment. (you can make an appointment for the date and session)',
          isSelect: false
        }]
    }
    
}
const vr1 = {
    title: ' Tourism Expo 2020',
    return: 'Go Back',
    url: '',
    navs: [{
        name: 'AI Exhibition',
        isActive: false,
        url: './'
      },{
        name: 'Live',
        isActive: false,
        url: 'http://qr28.cn/BLpEoA'
      },{
        name: 'Transition',
        isActive: false,
        url: 'https://thenextravelmarket.com/vptm2020'
      },{
        name: 'News',
        isActive: false,
        url: 'https://www.henglvwang.cn/list-221-1.html'
      }],
    name: 'VR',
    desc: 'Exhibition hall',
    d1: 'Comfortable Sichuan Exhibition',
    t1: 'A1、A2',
     add: 'ADD:',
  t2: '5000㎡',
    content: 'There are 18 booths and more than 500 exhibitors. The comfortable Sichuan exhibition area presents the cultural and tourism development achievements of various cities and prefectures in Sichuan Province, and comprehensively displays and promotes cultural tourism resources.'
}
const vr2 = {
  title: ' Tourism Expo 2020',
  return: 'Go Back',
  url: '',
  navs: [{
      name: 'AI Exhibition',
      isActive: false,
      url: './'
    },{
      name: 'Live',
      isActive: false,
      url: 'http://qr28.cn/BLpEoA'
    },{
      name: 'Transition',
      isActive: false,
      url: 'https://thenextravelmarket.com/vptm2020'
    },{
      name: 'News',
      isActive: false,
      url: 'https://www.henglvwang.cn/list-221-1.html'
    }],
  name: 'VR',
  desc: 'Exhibition hall',
  d1: 'Cultural Tourism China Innovation Pavilion',
  t1: 'A2、A3',
   add: 'ADD:',
  t2: '5000㎡',
  content: 'There are 28 booths and more than 600 exhibitors. Cultural Tourism China Innovation exhibition area comprehensively displays the cultural and tourism development achievements and innovation achievements of various provinces and regions, and selects cultural and tourism products, tourist souvenirs, folk gifts, local characteristic food and other cultural and tourism products. Among them, Beijing, Inner Mongolia, Henan, Fujian, Xinjiang, Guizhou, Shaanxi, Hubei, Gansu, Hunan, Sichuan tourism investment and other 11 provinces and cities and enterprises carried out special display, 10 provinces and cities including Gansu, Shanxi, Heilongjiang, Qinghai, Guangxi, Anhui, Hainan, Shandong, Ningxia and Liaoning, and 10 enterprises including Dalian Botao culture, Hubei zhilvyun and Sichuan Yarui research travel participated in the exhibition.'
}
const vr3 = {
  title: ' Tourism Expo 2020',
  return: 'Go Back',
  url: '',
  navs: [{
      name: 'AI Exhibition',
      isActive: false,
      url: './'
    },{
      name: 'Live',
      isActive: false,
      url: 'http://qr28.cn/BLpEoA'
    },{
      name: 'Transition',
      isActive: false,
      url: 'https://thenextravelmarket.com/vptm2020'
    },{
      name: 'News',
      isActive: false,
      url: 'https://www.henglvwang.cn/list-221-1.html'
    }],
  name: 'VR',
  desc: 'Exhibition hall',
  d1: 'City Gift Exhibition',
  t1: 'B',
   add: 'ADD:',
  t2: '2000㎡',
  content: 'There are 67 booths and more than 60 exhibitors. The city gift exhibition area focuses on displaying the top international and domestic cultural, tourism, cultural and creative works and tourism commodities. The international part has the British Museum, the Metropolitan Museum, the Russian Museum and other official cultural and creative products, while the domestic part has gifts of cultural and creative products from Leshan, Shanghai, Xinjiang, Jiangxi and Fujian. At the same time, there are intangible cultural heritage, Cultural Expo and other related cultural and creative products and tourism commodities in the exhibition area, which shows the current development vitality of cultural and creative industry.'
}
const vr4 = {
  title: ' Tourism Expo 2020',
  return: 'Go Back',
  url: '',
  navs: [{
      name: 'AI Exhibition',
      isActive: false,
      url: './'
    },{
      name: 'Live',
      isActive: false,
      url: 'http://qr28.cn/BLpEoA'
    },{
      name: 'Transition',
      isActive: false,
      url: 'https://thenextravelmarket.com/vptm2020'
    },{
      name: 'News',
      isActive: false,
      url: 'https://www.henglvwang.cn/list-221-1.html'
    }],
  name: 'VR',
  desc: 'Exhibition hall',
  d1: 'Tourism destination integration Exhibition',
  t1: 'D2',
   add: 'ADD:',
  t2: '3300㎡',
  content: 'There are 6 booths and more than 10 exhibitors. According to the layout of Chengdu Chongqing double city economic circle and stone carving art world heritage corridor, the exhibition hall of world tourism destination integration is set up in Chengdu, Chongqing, Leshan and Yibin, which integrates Cambodia, Wulong, Dazu and Nanchuan of Chongqing, and focuses on the world-class cultural and tourism resources of Bashu cultural tourism corridor.'
}
const vr5 = {
  title: ' Tourism Expo 2020',
  return: 'Go Back',
  url: '',
  navs: [{
      name: 'AI Exhibition',
      isActive: false,
      url: './'
    },{
      name: 'Live',
      isActive: false,
      url: 'http://qr28.cn/BLpEoA'
    },{
      name: 'Transition',
      isActive: false,
      url: 'https://thenextravelmarket.com/vptm2020'
    },{
      name: 'News',
      isActive: false,
      url: 'https://www.henglvwang.cn/list-221-1.html'
    }],
  name: 'VR',
  desc: 'Exhibition hall',
  d1: 'Cultural Tourism New Technology Exhibition',
  t1: 'F',
   add: 'ADD:',
  t2: '2000㎡',
  content: 'With more than 10 exhibitors, the exhibition focuses on new business forms and new products of cultural tourism, focusing on the theme of "new infrastructure, 5g, big data, Internet of things and blockchain", it focuses on the application of new cultural and tourism technologies, "smart travel Tianfu", "Zhiyou Leshan", small scenes of new cultural and tourism technologies, as well as smart toilets, driverless cars, unmanned sales, creative flight equipment and other cultural tourism New equipment, international tourism cloud exhibition and Tourism Expo live multi link interactive presentation.'
}
const en = {rotate,vr1,vr2,vr3,vr4,vr5}
export default en